module.exports = __webpack_public_path__ + "img/sl-6.webp";